
export const faqs = [
  {
    question: "What is included in the Universal Subscription?",
    answer: "The Universal Subscription gives you access to all AI staff members, unlimited tasks, and priority support. You can hire as many AI assistants as you need across different roles."
  },
  {
    question: "Can I cancel my subscription anytime?",
    answer: "Yes, you can cancel your subscription at any time. You'll continue to have access until the end of your current billing period."
  },
  {
    question: "How are AI staff members trained?",
    answer: "AI staff members are trained on general business knowledge and can be customized to your specific business needs. They learn from your feedback and interactions over time."
  },
  {
    question: "What happens when I upgrade my subscription?",
    answer: "When you upgrade, you'll immediately gain access to all the features of your new plan. Your billing will be prorated for the remainder of your current billing cycle."
  },
  {
    question: "Do I need technical skills to use AI staff?",
    answer: "No technical skills are required. Our platform is designed to be user-friendly and intuitive. You can interact with your AI staff through natural language conversations."
  }
];
